import PageHero from "@/components/sections/PageHero";
import Reviews from "@/components/sections/Reviews";
import GoogleReviews from "@/components/sections/GoogleReviews";
import ReviewForm from "@/components/sections/ReviewForm";

export default function AvisPage() {
  return (
    <>
      <PageHero
        eyebrow="/ Témoignages"
        title="Avis"
        accent="clients"
        description="Ce que disent nos clients de leur expérience Nova Clean Service. Honnêtement, et avec passion."
      />
      <Reviews hideHeader />
      <GoogleReviews />
      <ReviewForm />
    </>
  );
}
